export function getNextSibling(elem: Element, selector: string) {
	let sibling = elem.nextElementSibling
	while (sibling) {
		if (sibling.matches(selector)) return sibling
		sibling = sibling.nextElementSibling
	}
	return null // Return null if no match is found
}

export function getPreviousSibling(elem: Element, selector: string) {
	let sibling = elem.previousElementSibling
	while (sibling) {
		if (sibling.matches(selector)) return sibling
		sibling = sibling.previousElementSibling
	}
	return null // Return null if no match is found
}

// Example usage:
// const myElement = document.getElementById("myElement");
// const closestPreviousSibling = getPreviousSibling(myElement, ".target-class");

// Example usage:
// const myElement = document.getElementById("myElement");
// const closestNextSibling = getNextSibling(myElement, ".target-class");
